var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilRulerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.06641 6.94336L1.59651 6.41281L5.18362 2.8227L5.71373 2.29215L6.24428 2.82226L12.3319 8.9048L12.8625 9.43491L12.3324 9.96546L8.74524 13.5556L8.21513 14.0861L7.68458 13.556L1.59696 7.47347L1.06641 6.94336ZM3.18773 6.94247L8.21425 11.9648L10.7411 9.4358L9.69763 8.39316L8.34901 9.74291L7.22445 8.61929L8.57307 7.26954L7.90791 6.60494L6.52374 7.99027L5.39918 6.86664L6.78335 5.48131L5.71462 4.41347L3.18773 6.94247Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 15.6514L10.5301 15.1208L14.1172 11.5307L14.6473 11.0002L15.1779 11.5303L21.2655 17.6128L21.7961 18.1429L21.2659 18.6735L17.6788 22.2636L17.1487 22.7941L16.6182 22.264L10.5306 16.1815L10 15.6514ZM12.1213 15.6505L17.1478 20.6728L19.6747 18.1438L18.6312 17.1012L17.2826 18.4509L16.158 17.3273L17.5067 15.9775L16.8415 15.3129L15.4573 16.6983L14.3328 15.5746L15.7169 14.1893L14.6482 13.1215L12.1213 15.6505Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 17.25V21H6.75L17.81 9.94L14.06 6.19L3 17.25ZM5.92 19H5V18.08L14.06 9.02L14.98 9.94L5.92 19ZM20.71 5.63L18.37 3.29C18.17 3.09 17.92 3 17.66 3C17.4 3 17.15 3.1 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilRulerIcon);
export default __webpack_public_path__ + "static/media/pencil-ruler-icon.0863a08bdf3dc0d7e7c7bc9173dff2df.svg";
export { ForwardRef as ReactComponent };